import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "@/lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    const session_id = m ? m[1] : null;
    if (!session_id) { navigate("/login", { replace: true }); return; }
    (async () => {
      try {
        await api.post("/auth/session", { session_id });
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/dashboard", { replace: true });
        window.location.reload();
      } catch {
        navigate("/login", { replace: true });
      }
    })();
    // location.hash is captured on mount via ref; navigate is stable
  }, [location.hash, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="text-slate-500 text-sm">Completing sign-in...</div>
    </div>
  );
}
